<div class="authentication" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-sm="start stretch">
  <div class="authentication__left" fxFlex="50" fxHide fxShow.gt-sm>
    <img class="authentication__left__picture" src="assets/images/backgrounds/authentication.png" alt="background" />
    <div class="authentication__left__content">
      <h1 class="authentication__left__content__title">
        {{ 'LOGIN.TITLE' | translate }}
      </h1>
      <h2 class="authentication__left__content__subtitle">
        {{ loginCustomization?.description || ('LOGIN.DESCRIPTION' | translate) }}
      </h2>
    </div>
  </div>

  <div class="authentication__right" fxFlex="100" fxFlex.gt-sm="50">
    <div #card class="authentication__right__card" fxLayout="column">
      <div
        class="authentication__right__card__customization"
        [routerLink]="'/login'"
        fxLayout="row"
        fxLayoutGap="20px"
        fxLayoutAlign="start center"
      >
        <div class="authentication__right__card__customization_picture">
          <img [src]="loginCustomization?.logoUrl || 'assets/images/logos/grid_logo_icon.svg'" alt="Grid Control" />
        </div>
        <div fxLayout="column" fxLayoutAlign="start start">
          <p class="authentication__right__card__customization_title">
            {{ 'LOGIN.AUTH.TITLE' | translate }}
          </p>
          <p class="authentication__right__card__customization_subtitle">
            {{ loginCustomization?.accountName || 'Grid Control' }}
          </p>
        </div>
      </div>

      <div [@routeAnimation]="outlet.isActivated ? outlet.activatedRoute : ''">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center">
        <a
          class="authentication__right__card_link authentication__right__card_link--centered"
          href="https://fieldcontrol.com.br/termos-condicoes.html?utm_source=gestao-de-fornecedores&utm_medium=link&utm_campaign=login"
          target="_blank"
        >
          {{ 'LOGIN.TERMS_AND_PRIVACY' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
